<template>
  <div id="choose" class="wrapper">
    <!-- <gb /> -->

    <div id="logo" ref="logo">
      <img class="pci_logo" src="@/assets/images/new-logo.png" alt="star" />
    </div>

    <div id="choose_win" ref="choose_win">
      <div class="title">
        <h3>Choose Series / Level / Volume</h3>
      </div>
      <div class="content" v-if="load">
        <div class="item" v-for="(item, index) in series" :key="index">
          <div class="title_label">{{ item.series_name }}</div>

          <div class="item_list">
            <div
              class="item_list_content"
              v-for="(items, i) in item.levels"
              :key="i"
            >
              <div class="label">{{ items.level }}</div>
              <div class="item_content">
                <button
                  v-for="(items_c, i) in items.level_branch"
                  :key="i"
                  :class="{
                    active: level_branch === items_c.level_branch&&level_guid==item.series_guid,
                    lock: items_c.ebook_release == '0',
                  }"
                  @click="level_btn(item.series_name,item.series_name,items_c.level_branch,item.series_guid,items.level,items_c.book_resources_id,items_c.series_resources_id)"
                >
                <!-- &&level_guid==item.series_guid -->
                  {{ items_c.level_branch }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content" v-else style="display: flex; justify-content: center; align-items: center;">
        <h6 style="font-size: 48px; color: #fff; font-weight: 900; text-shadow: 0 5px 10px #000;">LOADING...</h6>
      </div>

      <!-- <div class="btn_wrapper" v-if="level && level_branch">
        <button @click="enter()">ENTER</button>
      </div>
      <div class="btn_wrapper" v-else>
        <button style="filter: grayscale(1); cursor: no-drop;">ENTER</button>
      </div> -->
    </div>
  </div>
</template>

<script setup>
import { token_expired } from '@/assets/js/token_expired';
import axios from "axios";
import Swal from "sweetalert2";
// import gb from "@/components/bg.vue";
import { ref, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
const router = useRouter();
const store = useStore();

// const choose_series = ref("");
const logo = ref(null);
const choose_win = ref(null);

const unit = ref("");
const level = ref("");
const level_branch = ref("");
const level_guid = ref("");
const level_type = ref("");

const public_link = ref("");
const book_link = ref("");

const load = ref(false);
const view = ref(false);

const series = ref([]);

function enter() {
  localStorage.setItem("unit", unit.value);
  localStorage.setItem("choose", level_branch.value);
  localStorage.setItem("level", level.value);
  localStorage.setItem("level_branch", level_branch.value);
  localStorage.setItem("level_guid", level_guid.value);
  localStorage.setItem("level_type", level_type.value);
  localStorage.setItem("public_type", level_type.value);
  localStorage.setItem("book_type", level_type.value);
  localStorage.setItem("public_link", public_link.value);
  localStorage.setItem("book_link", book_link.value);
  router.push("/main");
}

function get_info() {
  const FormData = require("form-data");
  let data = new FormData();
  data.append("tch_account", localStorage.getItem("ac"));

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/series-list/get`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {
      if(response.status == 520){
        get_info();
      }

      if (response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }
      
      token_expired(response, router);
      console.log(response);
      series.value = response.data.data;
      load.value = true;
    })
    .catch((error) => {
      if(error.status == 520){
        get_info();
      }
      token_expired(error, router);
      console.log(error);
    });
}

function level_btn(_unit,_level,_branch,_guid,_level_type,_book_resources,_public){
  // console.log(_unit);
  // console.log(_level);
  // console.log(_branch);
  // console.log(_guid);
  // console.log(_level_type);

  // console.log(_public);
  // console.log(_book_resources);

  unit.value = _unit;
  level.value = _level;
  level_branch.value = _branch;
  level_guid.value = _guid;
  level_type.value=_level_type;
  public_link.value = _public;
  book_link.value = _book_resources;

  enter()
}

const adjustZoom = (view) => {
  const baseWidth = 1920;
  const baseHeight = 1080;

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  const scaleWidth = windowWidth / baseWidth;
  const scaleHeight = windowHeight / baseHeight;

  const scale = Math.min(scaleWidth, scaleHeight);

  if (view) {
    if(view.id=='logo'){
      view.style.transform = `scale(${scale})`;
    }else{
      view.style.transform = `scale(${scale}) translate(-50%, -50%)`;
    }
  }
};

// function adjustScale(element) {
//   // 獲取當前的縮放比例
//   const currentZoom = window.devicePixelRatio || 1;

//   // 反向縮放，使之看起來像 100%
//   const inverseZoom = 1 / currentZoom;

//   // 使用 CSS transform 來反向縮放
//   if(inverseZoom !== 1){
//     if(element !== logo.value){
//       element.style.cssText = `transform:translate(-50%, -50%) scale(${inverseZoom}); max-height: calc(100vh + (180px - (180px*${inverseZoom})));`;
//     }else{
//       let yx = `-${100-(inverseZoom*100-inverseZoom)}%`
//       element.style.transform = `scale(${inverseZoom}) translate(${yx}, ${yx})`;
//     }
//   }
// }

onMounted(() => {
  get_info();
  adjustZoom(logo.value);
  adjustZoom(choose_win.value);
  view.value = true;
});
</script>

<style lang="scss" scoped>
.ban,
.lock {
  filter: grayscale(1);
  cursor: no-drop;
  pointer-events: none;
  background-color: #d4d4d4 !important;
  opacity: 0.3;
}
</style>
